import { createEntityAdapter } from '@reduxjs/toolkit';
import { Category } from './types';

const categoriesAdapter = createEntityAdapter<Category>({});

export default categoriesAdapter;
